import { render, staticRenderFns } from "./SingleCategory.vue?vue&type=template&id=d96dca38&scoped=true&"
import script from "./SingleCategory.vue?vue&type=script&lang=js&"
export * from "./SingleCategory.vue?vue&type=script&lang=js&"
import style0 from "./SingleCategory.vue?vue&type=style&index=0&id=d96dca38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96dca38",
  null
  
)

export default component.exports